import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { createSelector } from '@ngrx/store';

import { StatusActions, StatusActionTypes } from './status.actions';
import { StatusModel } from '../../models/status.model';

export interface State extends EntityState<StatusModel> {
  loading: boolean;
  selectedIdUpdateItem: string | null;
}

export const adapter: EntityAdapter<StatusModel> = createEntityAdapter<StatusModel>({
  selectId: (status: StatusModel) => status.id,
  sortComparer: false,
});

export const initialState: State = adapter.getInitialState({
  loading: false,
  selectedIdUpdateItem: null,
});

export function reducer(state = initialState, action: StatusActions): State {
  switch (action.type) {
    case StatusActionTypes.SearchAction: {
      return {
        ...state,
        loading: true,
      };
    }

    case StatusActionTypes.SearchSuccessAction: {
      return adapter.setAll(action.payload, {
        ...state,
        loading: false,
      });
    }

    case StatusActionTypes.SearchFailureAction: {
      return {
        ...state,
        loading: false,
      };
    }

    case StatusActionTypes.LoadProjectStatusesAction: {
      return {
        ...state,
        loading: true,
      };
    }

    case StatusActionTypes.LoadProjectStatusesSuccessAction: {
      return adapter.upsertMany(action.payload, {
        ...state,
        loading: false,
      });
    }

    case StatusActionTypes.LoadProjectStatusesFailureAction: {
      return {
        ...state,
        loading: false,
      };
    }

    case StatusActionTypes.SelectUpdateAction:
      return {
        ...state,
        selectedIdUpdateItem: action.payload,
      };

    case StatusActionTypes.SaveAction: {
      return {
        ...state,
        loading: true,
      };
    }

    case StatusActionTypes.CreateAction: {
      return {
        ...state,
        loading: true,
      };
    }

    case StatusActionTypes.CreateSuccessAction: {
      return adapter.addOne(action.payload, {
        ...state,
        loading: false,
      });
    }

    case StatusActionTypes.SaveSuccessAction: {
      return adapter.upsertOne(action.payload, {
        ...state,
        loading: false,
      });
    }

    case StatusActionTypes.DeleteAction: {
      return {
        ...state,
        loading: true,
      };
    }

    case StatusActionTypes.DeleteSuccessAction: {
      return adapter.removeOne(action.payload, {
        ...state,
      });
    }

    case StatusActionTypes.SortAction: {
      return {
        ...state,
        loading: true,
      };
    }

    case StatusActionTypes.SortSuccessAction: {
      const newEntities = { ...state.entities };
      const sortedEntities: { [key: string]: any } = {};

      // Пересоздаем объект entities в нужном порядке
      action.payload.id.forEach(id => {
        if (newEntities[id]) {
          sortedEntities[id] = newEntities[id];
        }
      });

      return {
        ...state,
        ids: action.payload.id,
        entities: sortedEntities,
        loading: false,
      };
    }

    case StatusActionTypes.StatusClearAction: {
      return adapter.removeAll({
        ...state,
        loading: false,
      });
    }

    default: {
      return state;
    }
  }
}

export const getLoading = (state: State) => state.loading;
export const getSelectedIdUpdateItem = (state: State) => state.selectedIdUpdateItem;

export const { selectIds, selectEntities, selectAll, selectTotal } = adapter.getSelectors();

export const getEntities = selectAll;

export const getEntitiesArray = createSelector(getEntities, entities => Object.values(entities));

export const getSelectedEntityForUpdate = createSelector(
  getEntities,
  getSelectedIdUpdateItem,
  (entities, selectedId) => entities[selectedId]
);

export const getBackLog = createSelector(getEntitiesArray, entities => entities.filter(_ => _.isBackLog)[0]);
